/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Merge_Replace_HelpInputs */

const en_plain_text_import_merge_replace_help = /** @type {(inputs: Plain_Text_Import_Merge_Replace_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge - Add events to existing group without deleting any other events. Replace - Removes all events in existing group prior to import`)
};

const fr_plain_text_import_merge_replace_help = /** @type {(inputs: Plain_Text_Import_Merge_Replace_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionner - Ajouter des evenements au groupe existant sans supprimer les autres evenements. Remplacer - Supprime tous les evenements du groupe existant avant l'importation`)
};

const de_plain_text_import_merge_replace_help = /** @type {(inputs: Plain_Text_Import_Merge_Replace_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenführen – Fügt Ereignisse zu einer bestehenden Gruppe hinzu, ohne andere Ereignisse zu löschen. Ersetzen – Entfernt alle Ereignisse in der bestehenden Gruppe vor dem Import.`)
};

const it_plain_text_import_merge_replace_help = /** @type {(inputs: Plain_Text_Import_Merge_Replace_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisci: aggiunge eventi al gruppo esistente senza eliminarne altri. Sostituisci: rimuove tutti gli eventi nel gruppo esistente prima dell'importazione.`)
};

const ru_plain_text_import_merge_replace_help = /** @type {(inputs: Plain_Text_Import_Merge_Replace_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объединение — добавление событий в существующую группу без удаления других событий. Замена — удаление всех событий из существующей группы перед импортом.`)
};

const es_plain_text_import_merge_replace_help = /** @type {(inputs: Plain_Text_Import_Merge_Replace_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionar: Agrega eventos al grupo existente sin eliminar otros eventos. Reemplazar: Elimina todos los eventos del grupo existente antes de importar.`)
};

const zh_cn2_plain_text_import_merge_replace_help = /** @type {(inputs: Plain_Text_Import_Merge_Replace_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并 - 将事件添加到现有组，而不删除任何其他事件。替换 - 在导入之前删除现有组中的所有事件。`)
};

const ja_plain_text_import_merge_replace_help = /** @type {(inputs: Plain_Text_Import_Merge_Replace_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マージ - 他のイベントを削除せずに既存のグループにイベントを追加します。置換 - インポート前に既存のグループ内のすべてのイベントを削除します。`)
};

const hi_plain_text_import_merge_replace_help = /** @type {(inputs: Plain_Text_Import_Merge_Replace_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मर्ज - अन्य किसी भी इवेंट को हटाए बिना मौजूदा समूह में इवेंट जोड़ें। रिप्लेस - आयात करने से पहले मौजूदा समूह के सभी इवेंट हटा देता है।`)
};

const pt_pt2_plain_text_import_merge_replace_help = /** @type {(inputs: Plain_Text_Import_Merge_Replace_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesclar - Adiciona eventos a um grupo existente sem excluir nenhum outro evento. Substituir - Remove todos os eventos do grupo existente antes da importação.`)
};

/**
* | output |
* | --- |
* | "Merge - Add events to existing group without deleting any other events. Replace - Removes all events in existing group prior to import" |
*
* @param {Plain_Text_Import_Merge_Replace_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_merge_replace_help = /** @type {((inputs?: Plain_Text_Import_Merge_Replace_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Merge_Replace_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_merge_replace_help(inputs)
	if (locale === "de") return de_plain_text_import_merge_replace_help(inputs)
	if (locale === "it") return it_plain_text_import_merge_replace_help(inputs)
	if (locale === "ru") return ru_plain_text_import_merge_replace_help(inputs)
	if (locale === "es") return es_plain_text_import_merge_replace_help(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_merge_replace_help(inputs)
	if (locale === "ja") return ja_plain_text_import_merge_replace_help(inputs)
	if (locale === "hi") return hi_plain_text_import_merge_replace_help(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_merge_replace_help(inputs)
	return en_plain_text_import_merge_replace_help(inputs)
});